import '../../styles/crud-progress-reporter.scss';
import {Button} from 'forms';
import {CollectionField} from '../fields';
import {FieldSchema, CrudStatus, EntryStatus} from '../types';
import CrudHub from '../CrudHub';
import {PanelRenderer} from '../renderers';
import noop from 'lodash/noop';
import React from 'react';
import t from 'rcm-i18n';

interface Props<T extends object> {
    onClose: () => void;
    onStop: () => void;
    schema: FieldSchema[];
    status: CrudStatus;
    statuses: Array<EntryStatus<T>>;
}

const CrudProgressReporter = <T extends object>({
    status,
    statuses,
    schema,
    onClose = noop,
    onStop = noop,
}: Props<T>) => {
    const schemaReview = schema
        .filter((f) => !f.hidden)
        .map((f) => ({ ...f, Type: null, props: { } }));
    return <div className="crud-progress-reporter">
        {statuses.map((s, i) => <CollectionField key={i}
            Renderer={PanelRenderer}
            panel={
                s.status === 'error' ? 'danger' :
                s.status === 'saved' ? 'success' :
                'default'
            }
            label={
                (
                    s.status === 'error' ? 'ERROR: ' :
                    s.status === 'saved' ? 'SUCCESS: ' :
                    ''
                ) +
                s.message
            }
            schema={schemaReview}
            value={s.entry}
        />)}
        <CrudHub.Foot.Send>
            <Button
                btn="default"
                className="pull-left"
                disabled={status === 'saving'}
                icon="chevron-left"
                text={t('Back')}
                onClick={onClose}
            />
            {(status === 'saving' || status === 'interrupted') ? <Button
                btn="danger"
                className="pull-right"
                disabled={status === 'interrupted'}
                icon="stop"
                onClick={onStop}
                text={t('Stop')}
            /> : <Button
                btn="default"
                className="pull-right"
                onClick={onClose}
                text={t('Done')}
            />}
        </CrudHub.Foot.Send>
    </div>;
};

export default CrudProgressReporter;
